export const namespace = 'partner';
